import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from '../AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/free-solid-svg-icons';
import s from '../styles/Navbar.module.css'; // Подключение стилей
import Avatar from './Avatar'; // путь к файлу компонента
import EmailUnconfirmedModal from './EmailUnconfirmedModal';


function Navbar() {
  const { currentUser, loading, fetchCurrentUser } = useContext(AuthContext);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const navigate = useNavigate();

  // Если идет первичная загрузка профиля, вообще ничего не рендерим во избежание прыжков интерфейса
  if (loading) return null; 

  const handleAvatarClick = () => navigate("/profilecabinet");
  const handleWalletClick = () => navigate("/dashboard?tab=payments");
  const handleLogoClick = (e) => { e.preventDefault(); navigate('/'); };

  const isEmailUnconfirmed = Boolean(currentUser) && currentUser.is_login_confirmed === false;

 
  return (
    <>
    <nav className={currentUser ? s.navbar : s.invisible}>
        <div className={s.container}>
         
        <a href="/" onClick={handleLogoClick}>
          <img className={s.logo} src="/logo_pulseads2.svg" alt="Логотип" />
        </a>

            </div>
      {/* Правая часть с иконками */}
      
      {/* Значок неподтверждённой почты — по центру navbar */}
      {isEmailUnconfirmed && (
        <div className={s.navCenter}>
          <button
            type="button"
            className={s.unconfirmedBadge}
            onClick={() => setIsEmailModalOpen(true)}
          >
            ⚠ Почта не подтверждена
          </button>
        </div>
      )}

        {currentUser ? (
          <>
          <div className={s.balance_menu_all_div}>
              <div onClick={handleWalletClick} className={s.balance_days_div}>
                  <div className={s.balance_div}>
                  <FontAwesomeIcon icon={faWallet} className={s.faWallet}/>
                  {currentUser.balance}р.
                  </div>
                  <div className={`${s.days_div} ${currentUser.days_remaining < 3 ? s.days_div_red : ''}`}>
                      <p className={s.tarif_name}>
                      {currentUser.tarif_name}
                      </p>
                      на
                      <p className={s.days_div_p}>
                        {currentUser.days_remaining}
                      </p>
                      <p className={s.days_div_p}>дн.</p>
                    </div>

              </div>
              <div  onClick={handleAvatarClick} className={s.navbar_links}>
                  {/* Отображаем иконки для авторизованного пользователя */}
                  <Avatar userId={currentUser.id} />          
              </div>
          </div>
          
          </>
        ) : (
          <>
           
          </>
        )}
     
    </nav>
    {isEmailModalOpen && isEmailUnconfirmed && (
      <EmailUnconfirmedModal
        currentUser={currentUser}
        onClose={() => setIsEmailModalOpen(false)}
        onUserUpdated={fetchCurrentUser}
      />
    )}
    </>
  );
};

export default Navbar;
